export const ReviewableQuerys = {
    data() {
        return {
            // set variables from the route query
            query_user: this.$route.query.user,
            query_tags: this.$route.query.tags__name,
            query_search: this.$route.query.search
        }
    },
    watch: {
        '$route'(to, from) {
            // watch for any changes in the route and set the variables           
            this.query_user = to.query.user
            this.query_tags = to.query.tags__name
            this.query_search =  to.query.search
        },
    },
    methods: {
        UpdateQuery(key, value) {
            // change the router query, and change the data
            // this is only when query is removed?
            console.log('UpdateQuery(): ' + key + '=' + value)

            // append router query
            this.$router.push({
                query: {
                    ...this.$route.query,
                    [key]: value
                }
            })
        },
        UpdateSearch() {
            this.UpdateQuery('search', this.query_search)
        }
    },
}
